/**
 * Mit lehet kezdeni az ertesitesi engedellyel EZEN a keszuleken.
 *
 * Azert kulon fajl, mert ket helyen kell (a figyelmeztető sav es a
 * Beallitasok), es mert az iOS-en mas a valasz, mint mindenhol mashol:
 *
 *  - a Notification API CSAK a kezdokepernyore tett alkalmazasban letezik,
 *    Safari-fulon nincs;
 *  - nincs cimsor es nincs lakat ikon, tehat az "allitsd at az oldal
 *    beallitasaiban" tanacs ott ertelmetlen;
 *  - egy elutasitott engedelyt a felulet SEHOGY nem tud visszakerni.
 */

/** iPhone vagy iPad. Az iPadOS 13 ota Mac-nek adja ki magat - a tapintas arulja el. */
export function isIos(): boolean {
  if (typeof navigator === 'undefined') return false;
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}

/** A kezdokepernyore tett alkalmazaskent futunk-e (iOS-en ez a sajat jelzes). */
export function isStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia?.('(display-mode: standalone)').matches ||
    (window.navigator as { standalone?: boolean }).standalone === true
  );
}

/**
 * Mi a teendo, ha az engedelyt egyszer mar elutasitottak.
 *
 * iOS-en ez nem egy kapcsolo atallitasa: amig egy kezdokepernyos alkalmazas
 * nem kapott engedelyt, MEG CSAK MEG SEM JELENIK az iOS ertesitesi
 * beallitasai kozott - tehat ott nincs mit bekapcsolni. Marad az
 * ujratelepites, a weboldal-adatok torlesevel egyutt (a Safari az engedelyt a
 * domainhez is koti, nem csak a kezdokepernyos ikonhoz).
 */
export function deniedHelp(): string {
  return isIos()
    ? 'iPhone-on ezt csak újratelepítéssel lehet visszavonni: töröld az AVSlacket a kezdőképernyőről, a Beállítások → Safari → Speciális → Weboldaladatok alatt töröld az avslack adatait, majd tedd ki újra a kezdőképernyőre, és ott engedélyezd.'
    : 'A címsorban a lakat ikonra kattintva engedélyezheted az értesítéseket ennek az oldalnak.';
}
